import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupSubEntityInfoUtils } from '../../base/UserGroupSubEntityInfoUtils';
import { ConstructionSiteDto } from './ConstructionSiteDto';
export function createConstructionSiteEntityInfo<TEntity extends ConstructionSiteDto>(options: CreateEntityInfoOptions<ConstructionSiteDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.ConstructionSite, TEntity> {
  return {
    entityName: EntityName.ConstructionSite,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, ConstructionSiteDto, TEntity>({
      ...UserGroupSubEntityInfoUtils.createBaseFieldInfos(),
      name: {
        name: 'name',
        defaultValue: ''
      },
      archived: {
        name: 'archived',
        defaultValue: false
      },
      location: {
        name: 'location',
        innerInfo: {
          latitude: {
            name: 'latitude'
          },
          longitude: {
            name: 'longitude'
          }
        },
        defaultValue: null
      },
      compilationId: {
        name: 'compilationId'
      }
    }, options.additionalFieldInfos)
  };
}